import css from 'styled-jsx/css';

const styles = css.global`#bens-servicos-pf-parcela-facilitada {
  padding: 0 0 32px;
  overflow: hidden;
}
#bens-servicos-pf-parcela-facilitada .ctn-home-24#container-reference {
  /* display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px; */
  margin-top: 32px;
}

.parcela-facilitada-textos-carrossel {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
}

.parcela-facilitada-textos {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  max-width: 500px;
}

.parcela-facilitada-textos-titulo {
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
}

.parcela-facilitada-textos-conteudo {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

.parcela-facilitada-textos-conteudo ul {
  list-style-position: inside;
  padding-left: 10px;
}

.parcela-facilitada-textos-conteudo ul li::marker {
  font-size: 15px;
}

.parcela-facilitada-carrossel {
  width: 100%;
  overflow: visible;
}

#bens-servicos-pf-parcela-facilitada .parcela-facilitada-carrossel-slide {
  width: 280px;
  flex: 0 0 280px;
  margin-left: 16px;
}

#bens-servicos-pf-parcela-facilitada .parcela-facilitada-carrossel-slide a {
  padding-bottom: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.parcela-facilitada-carrossel-slide-titulo {
  color: #444;
  font-family: "SantanderText";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: 8px;
}

#bens-servicos-pf-parcela-facilitada .parcela-facilitada-carrossel-slide img {
  width: 100%;
  border-radius: 4px;
}

.parcela-facilitada-carrossel-slide-link {
  display: flex;
  width: 134px;
  height: 48px;
  min-width: 91px;
  max-width: 304px;
  padding: 8px;
  align-items: center;
  gap: 8px;
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  text-decoration-line: underline;
}

.parcela-facilitada-carrossel-slide-link.flip-card-back-link {
  color: #CCCCCC;
}

#bens-servicos-pf-parcela-facilitada .home-pagination {
  margin-top: 10px;
}

#bens-servicos-pf-parcela-facilitada .home-pagination .embla__prev.enable-mobile-arrows, 
#bens-servicos-pf-parcela-facilitada  .home-pagination .embla__next.enable-mobile-arrows {
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
}

.parcela-facilitada-numbers, 
.parcela-facilitada-numbers-cards {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.parcela-facilitada-numbers-card {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.numbers-card-number {
  color: #444;
  font-family: "SantanderText";
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}

.numbers-card-number b {
  font-size: 24px;
  font-weight: 600;
}

.numbers-card-text {
  color: #444;
  text-align: center;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

.btn-lojas-parceiras {
  width: 272px;
  height: 48px;
  min-width: 88px;
  max-width: 328px;
  margin: auto;
}

.flip-card {
  display: block;
  perspective: 1000px;
  height: 399px;
}

.flip-toggle {
  display: none;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}

.flip-toggle:checked + .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  top: 0;
  left: 0;
  cursor: pointer;
}

.flip-card-front {
  z-index: 2;
}

.flip-card-back {
  transform: rotateY(180deg);
  /* background: #f9f9f9; */
}

.flip-card-back-infos {
  height: 300px;
  background: #fff;
  padding: 8px 16px 0px 16px;
  position: relative;
}

.flip-card-back-infos-title {
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 48px;
}

.flip-card-back-infos-text {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-top: 16px;
}

#bens-servicos-pf-parcela-facilitada .parcela-facilitada-carrossel-slide .ic-close-card {
  position: absolute;
  top: 18px;
  right: 10px;
  width: 20px;
  border-radius: 0;
}


@media (min-width: 992px) {
  #bens-servicos-pf-parcela-facilitada {
    padding: 0 0 56px;
  }

  #bens-servicos-pf-parcela-facilitada .ctn-home-24#container-reference {
    margin-top: 56px;
  }

  .parcela-facilitada-textos-titulo {
    font-size: 56px;
    line-height: 120%;
    max-width: 410px;
  }
  
  .parcela-facilitada-textos-carrossel {
    flex-direction: row;
    align-items: flex-start;
  }

  .parcela-facilitada-textos {
    gap: 24px;
    min-width: 500px;
  }

  .parcela-facilitada-carrossel {
    /* width: 996px;
    overflow: hidden;
    margin-right: -193px; */
    overflow: hidden;
    flex: 1;
    /* margin-right: -265px; */
  }

  #bens-servicos-pf-parcela-facilitada .parcela-facilitada-carrossel-slide {
    width: 300px;
    flex: 0 0 300px;
    margin-left: 0;
    margin-right: 24px;
  }


  


  .parcela-facilitada-numbers {
    gap: 40px;
  }

  .parcela-facilitada-numbers-cards {
    flex-direction: row;
  }

  .parcela-facilitada-numbers-card {
    width: 327px;
  }

  .numbers-card-number {
    font-size: 40px;
  }

  #bens-servicos-pf-parcela-facilitada #container-parcela {
    padding-right: 0;
    margin-right: 0;
    max-width: 100%;
    box-sizing: border-box;
  }

  #container-parcela .parcela-facilitada-textos-carrossel {
    flex: 1;
    box-sizing: border-box;
    overflow: hidden;
    margin-right: 0;
    margin-left: auto;
  }

   .flip-card {
    height: 519px;
  }

  .flip-card-back-infos {
    height: 420px;
  }
}

@media (min-width: 1750px) {
  #bens-servicos-pf-parcela-facilitada .home-pagination {
    display: none;
  }
}`;

export default styles;